import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b5ea64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "address-receive mx-autor px-4 py-28"
}
const _hoisted_3 = { class: "flex justify-center mb-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-2xl font-semibold mb-4" }, " Input your address to receive NFTs ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-6" }, " Enter your address to receive NFTs. Only a BSC Chain address is acceptable. ", -1))
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium mb-2 text-gray-description" }, " Send NFTs to this wallet : ", -1))
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Send ")
const _hoisted_10 = {
  key: 1,
  class: "mx-autor px-4 py-28 space-y-4"
}
const _hoisted_11 = { class: "flex justify-center mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-2xl" }, " Next step : Confirm your email ", -1))
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-description" }, "We’ll send you an email to ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-gray-description" }, " In order to complete the NFTs transfer process please click the confirmation link in your email. ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-sm text-gray-description" }, " Note : The confirmation link in the email will expire within the next 15 minutes please make sure to confirm within that time. ", -1))

import { defineComponent, computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import IconAddressReceive from '@/components/Icons/IconAddressRecevice.vue';
import IconMail from '@/components/Icons/IconMail.vue';
import * as api from '@/apis';
import useReceive from '@/composables/useReceive';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const email = computed(() => localStorage.getItem('receive_email'));
const wallet = ref('');
const isAddressReceive = computed(() => {
  return route?.name === 'AddressReceive';
});
const { receive } = useReceive();

const toggleSend = async () => {
  const channel = localStorage.getItem('receive_channel');

  const paramReceive = {
    paymentId: localStorage.getItem('receive_id') as string,
    recipient: wallet.value,
  };
  if (channel === '2') {
    await api.receiveSendByGuest(paramReceive);
    router.push(`/landing/send-nft/${paramReceive.recipient}/confirm`);
  } else {
    receive(wallet.value);
  }
};

defineComponent({
  name: 'AddressReceive',
});

return (_ctx: any,_cache: any) => {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isAddressReceive))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(IconAddressReceive)
          ]),
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_BaseInputText, {
              modelValue: wallet.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((wallet).value = $event)),
              placeholder: "Input wallet address"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_BaseButton, {
              class: "w-full",
              "color-scheme": "primary",
              height: "40px",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSend())),
              "data-testid": "send-nft-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(IconMail)
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_unref(email)), 1)
          ]),
          _hoisted_15,
          _hoisted_16
        ]))
  ]))
}
}

})